module.exports = __webpack_public_path__ + "static/media/e6.ca7b3671.jpg";